import { CostAssessmentRecordRow, LandInput } from "../../types";
import { diminishingBalanceMethod, DiminishingBalanceOptions } from "./diminishing-balance";
import { mixedMethod, MixedOptions } from "./mixed";
import { sCurveMethod, SCurveOptions } from "./s-curve-method";
import { straightLineMethod, StraightLineOptions } from "./straight-line-method";


export type DepreciationOptions 
  = SCurveOptions
  | StraightLineOptions
  | DiminishingBalanceOptions
  | MixedOptions

export interface RecordOptions {
  valuationDate: Date,
  buildingConstructionDate: Date,
  useLandValueInput: boolean
  useSizeAsQuantity: boolean,
  landInput: LandInput,
  size: number,
  level: number
}

export function depreciation(
  records: CostAssessmentRecordRow[],
  recordOptions: RecordOptions,
  options: DepreciationOptions
) {
  if (options === null) return null;
  if (options.kind === 's-curve') {
    return sCurveMethod(records, recordOptions, options)
  }
  if (options.kind === 'straight-line') {
    return straightLineMethod(records, recordOptions, options)
  }
  if (options.kind === 'diminishing-balance') {
    return diminishingBalanceMethod(records, recordOptions, options)
  }
  if (options.kind === 'mixed') {
    return mixedMethod(records, recordOptions, options)
  }
  return null
}

export function getDepreciationOptions(
  methodId: number,
  sCurveSteepness: number,
  economicLife: number,
  salvageValue: number,
  depreciationFactorPerYear: number,
  levelId: number,
  from: string
): DepreciationOptions {
  if (methodId === 2) {
    const options: SCurveOptions = {
      kind: 's-curve',
      steepness: sCurveSteepness,
      economicLife
    }
    return options
  }
  if (methodId === 5) {
    const options: DiminishingBalanceOptions = {
      kind: 'diminishing-balance',
      economicLife,
      depreciationFactorPerYear
    }
    return options
  }
  if (methodId === 6) {
    const options: StraightLineOptions = {
      kind: 'straight-line',
      salvageValue: salvageValue,
      economicLife
    }
    return options
  }
  if (methodId === 10) {
    const options: MixedOptions = {
      kind: 'mixed',
      levelId: levelId,
      from
    }
    return options
  }
  return null
}